import { type InjectionKey, inject } from 'vue';
import type { GeoConfig } from './places.types.ts';

export const GEO_CONFIG_KEY: InjectionKey<GeoConfig> = Symbol('geo-config');

export const ADDRESS_PRIMARY_TYPES = [
  'street_address',
  'premise',
  'subpremise',
  'route',
];

export const ADDRESS_PLACE_FIELDS = ['addressComponents', 'formattedAddress'];

export const useGeoConfig = () => inject(GEO_CONFIG_KEY, null);

export const useIsPlacesAvailable = () =>
  Boolean(useGeoConfig()?.googleMapsApiKey);

export const useIsMapAvailable = () => {
  const config = useGeoConfig();
  return Boolean(config?.googleMapsApiKey && config.googleMapId);
};
